


import { defineComponent, onMounted, ref, onBeforeUnmount, onUnmounted, watch } from 'vue';
import { MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import ComponentCommon from '../../../../domain/Functions/ComponentCommon';
import CalendarTypeConst from '../../../../domain/Constants/CalendarTypeConst';
import { Container } from 'inversify';
import WidgetComponentDataTree from '../../../../../designer/domain/widgetComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import { IapCatalogType } from '../../../../../catalog/domain/iapCatalogType';
import CustomValidate from '../../shared/CustomValidate.vue';
import { Dictionary } from '../../../../../expression/domain/dictionary';
import { useStore } from 'vuex';	

export default defineComponent({
    name: 'dynamic_calendar',

    components: {
        CustomValidate
    },
    props:
    {

        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => WidgetComponentDataTree,
            default: () => ({})
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },
        dataSources: {
            type: Object as () => IapComponentDataSource[],
            default: () => ({})
        },
        slotProps: {
            type: Object,
            default: () => ({})
        },
        rootParentAttr: {
            type: Object as () => IapComponentAttribute[],
            default: () => ({})
        },

    },
    setup(props, context) {
        //

        
        const store = useStore();
        const { vmodel, getPropertyValue, getPropertyNumberValue, getPropertyBooleanValue, loaded, componentData, resolveExpressions, getCatalogValue, baseOnUnmount, v$, submitted, canEdit, baseOnMounted, baseOnBeforeUnmount, isValidData, fieldKey, fieldKeyComponentDataSourceId } = ComponentCommon(props, context,store);

        const calendarComponentRef = ref();
        const showMessage = (msg: string) => {
            MessageService.showToast(MessageType.Correcto, '', msg)
        }



        /*
                    INICIO Parche para el calendario que nu¡o rula bien al insertar manual las fechas
                    Hilo del caso en: https://github.com/primefaces/primevue/issues/3624
        */

        /**
         * Prevent PrimeVue's Calendar component from stealing focus from its own
         * input, preventing users from manually entering dates
         *
         * see https://github.com/primefaces/primevue/issues/3624
         */
        
        const fixCalendarFocusTrap = () => {
            const componentExists = !!calendarComponentRef.value;
            if (!componentExists) return;

            const alreadyMonkeyPatched =
                !!calendarComponentRef.value.originalUpdateFocusFunc;
            if (alreadyMonkeyPatched) return;

            calendarComponentRef.value.originalUpdateFocusFunc =
                calendarComponentRef.value.updateFocus;

            calendarComponentRef.value.updateFocus = () => {
                const inputEl = calendarComponentRef.value.input;
                const inputElHasFocus = inputEl && inputEl == document.activeElement;
                if (!inputElHasFocus) {
                    calendarComponentRef.value.originalUpdateFocusFunc();
                }
            };
        };

        watch(calendarComponentRef, () => fixCalendarFocusTrap(), {
            immediate: true,
        });

            /* 
              FIN  Parche para el calendario que nu¡o rula bien al insertar manual las fechas
            
            */

        onMounted(() => {

            baseOnMounted();

        })

        onBeforeUnmount(() => {

            baseOnBeforeUnmount();
        })


        onUnmounted(() => {

            baseOnUnmount();

        })

        return {
            MessageService,
            MessageType,
            showMessage,
            getPropertyValue,
            getPropertyBooleanValue,
            vmodel,
            CalendarTypeConst,
            getPropertyNumberValue,
            getCatalogValue,
            loaded,
            v$,
            submitted,
            canEdit,
            isValidData,
            fieldKey,
            fieldKeyComponentDataSourceId,
            calendarComponentRef
        };
    },
});
